import React, { Fragment } from "react";
import { Helmet } from "react-helmet";
import { Link } from "react-router-dom";
import Header from "../../components/Header/Header";
import PageTitle from "../../components/pagetitle/PageTitle";
import Scrollbar from "../../components/scrollbar/scrollbar";
import Footer from "../../components/footer/Footer";

const ManagedCloudPage: React.FC = () => {
    return (
        <Fragment>
            <Helmet>
                <title>Managed Cloud Solutions | AquarLabs</title>
                <meta name="description" content="Focus on your business while we manage your cloud infrastructure. AquarLabs provides 24/7 managed cloud services with proactive monitoring, optimization, and support." />
                <meta name="keywords" content="managed cloud, cloud management, cloud services, cloud support, cloud monitoring, DevOps, cloud operations, AquarLabs" />
            </Helmet>
            <div className="about-page inner-page">
                <div className="body_wrap o-clip">
                    <Header />
                    <main>
                        <PageTitle pageTitle="Managed Cloud Solutions" pagesub="Managed Cloud" parentPage="Solutions" parentLink="/service" />

                        {/* Hero Section */}
                        <section className="service-hero-section" style={{ padding: "80px 0", background: "linear-gradient(135deg, rgba(252, 144, 56, 0.1) 0%, rgba(0, 2, 15, 0.8) 100%)" }}>
                            <div className="container">
                                <div className="row">
                                    <div className="col-lg-8">
                                        <h1 style={{ fontSize: "3rem", marginBottom: "20px", color: "#fff" }}>Managed Cloud Solutions</h1>
                                        <p style={{ fontSize: "1.25rem", color: "rgba(255,255,255,0.8)", lineHeight: "1.8" }}>
                                            Offload the complexity of cloud operations to our expert team. We handle everything from infrastructure management to security, so you can focus on innovation and growth.
                                        </p>
                                        <Link to="/contact-us" className="thm-btn agency-btn" style={{ marginTop: "30px", display: "inline-block" }}>
                                            <span className="text">Get Started</span>
                                        </Link>
                                    </div>
                                </div>
                            </div>
                        </section>

                        {/* Overview Section */}
                        <section style={{ padding: "80px 0" }}>
                            <div className="container">
                                <span style={{ color: "#fc9038", fontSize: "14px", textTransform: "uppercase", letterSpacing: "2px" }}>Overview</span>
                                <h2 style={{ fontSize: "2.5rem", margin: "15px 0 30px", color: "#fff" }}>Expert Cloud Management, Zero Hassle</h2>
                                <p style={{ fontSize: "1.1rem", lineHeight: "1.8", color: "rgba(255,255,255,0.8)" }}>
                                    AquarLabs' managed cloud services provide comprehensive oversight of your cloud infrastructure, eliminating the need for large in-house operations teams. Our certified engineers monitor, maintain, and optimize your environments around the clock, ensuring peak performance and security.
                                </p>
                                <p style={{ fontSize: "1.1rem", lineHeight: "1.8", color: "rgba(255,255,255,0.8)", marginTop: "20px" }}>
                                    From routine maintenance to incident response, we proactively address issues before they impact your business. Our managed services scale with your needs, providing predictable costs and expert support whenever you need it.
                                </p>
                            </div>
                        </section>

                        {/* Services Section */}
                        <section style={{ padding: "80px 0", background: "rgba(0,2,15,0.3)" }}>
                            <div className="container">
                                <div className="row">
                                    <div className="col-lg-4">
                                        <span style={{ color: "#fc9038", fontSize: "14px", textTransform: "uppercase" }}>Our Capabilities</span>
                                        <h2 style={{ fontSize: "2rem", margin: "15px 0", color: "#fff" }}>Full-Spectrum Managed Services</h2>
                                    </div>
                                    <div className="col-lg-8">
                                        <div className="row">
                                            {[
                                                {
                                                    title: "24/7 Monitoring & Support",
                                                    desc: "Round-the-clock infrastructure monitoring and rapid incident response.",
                                                    items: ["Real-time Alerting", "Incident Management", "SLA-backed Response Times"]
                                                },
                                                {
                                                    title: "Security Management",
                                                    desc: "Comprehensive security operations to protect your assets.",
                                                    items: ["Threat Detection & Response", "Vulnerability Scanning", "Security Patch Management"]
                                                },
                                                {
                                                    title: "Performance Optimization",
                                                    desc: "Continuous tuning for optimal speed and efficiency.",
                                                    items: ["Resource Right-sizing", "Auto-scaling Configuration", "Application Performance Monitoring"]
                                                },
                                                {
                                                    title: "Cost Management",
                                                    desc: "Maximize ROI with intelligent cloud spending strategies.",
                                                    items: ["Reserved Instance Planning", "Waste Elimination", "Budget Alerts & Reporting"]
                                                }
                                            ].map((activity, index) => (
                                                <div key={index} className="col-md-6" style={{ marginBottom: "30px" }}>
                                                    <div style={{ background: "rgba(255,255,255,0.03)", border: "1px solid rgba(255,255,255,0.1)", borderRadius: "12px", padding: "30px", height: "100%" }}>
                                                        <h3 style={{ fontSize: "1.25rem", color: "#fff", marginBottom: "15px" }}>
                                                            <span style={{ color: "#fc9038" }}>●</span> {activity.title}
                                                        </h3>
                                                        <p style={{ fontSize: "0.95rem", color: "rgba(255,255,255,0.7)", marginBottom: "15px" }}>{activity.desc}</p>
                                                        <ul style={{ listStyle: "none", padding: 0 }}>
                                                            {activity.items.map((item, i) => (
                                                                <li key={i} style={{ fontSize: "0.9rem", color: "rgba(255,255,255,0.6)", padding: "5px 0" }}>→ {item}</li>
                                                            ))}
                                                        </ul>
                                                    </div>
                                                </div>
                                            ))}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>

                        {/* Why Us Section */}
                        <section style={{ padding: "80px 0", background: "#0a0a0a" }}>
                            <div className="container">
                                <div className="text-center" style={{ marginBottom: "50px" }}>
                                    <span style={{ color: "#fc9038", fontSize: "14px", textTransform: "uppercase", letterSpacing: "2px" }}>Why Us</span>
                                    <h2 style={{ fontSize: "2.5rem", margin: "15px 0 20px", color: "#fff" }}>Why Choose AquarLabs for Managed Cloud?</h2>
                                    <p style={{ fontSize: "1rem", color: "rgba(255,255,255,0.6)", maxWidth: "700px", margin: "0 auto" }}>
                                        Our team becomes an extension of yours, providing enterprise-grade operations expertise.
                                    </p>
                                </div>
                                <div className="row">
                                    {[
                                        { title: "Certified Engineers", desc: "AWS, Azure, and GCP certified professionals managing your infrastructure." },
                                        { title: "Proactive Approach", desc: "We fix issues before they become problems with predictive monitoring." },
                                        { title: "Flexible SLAs", desc: "Choose service levels that match your business requirements and budget." },
                                        { title: "Transparent Reporting", desc: "Monthly reports with insights into performance, security, and costs." },
                                        { title: "Seamless Onboarding", desc: "Zero-disruption transition with comprehensive knowledge transfer." },
                                        { title: "Vendor Agnostic", desc: "Support for AWS, Azure, GCP, and multi-cloud environments." }
                                    ].map((item, index) => (
                                        <div key={index} className="col-lg-6" style={{ marginBottom: "20px" }}>
                                            <div style={{
                                                background: "rgba(20, 20, 20, 0.8)",
                                                border: "1px solid rgba(252, 144, 56, 0.4)",
                                                borderRadius: "16px",
                                                padding: "28px 30px",
                                                height: "100%",
                                                display: "flex",
                                                alignItems: "flex-start",
                                                gap: "15px"
                                            }}>
                                                <div style={{
                                                    minWidth: "40px",
                                                    height: "40px",
                                                    borderRadius: "8px",
                                                    background: "rgba(252, 144, 56, 0.1)",
                                                    display: "flex",
                                                    alignItems: "center",
                                                    justifyContent: "center"
                                                }}>
                                                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                        <path d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z" stroke="#fc9038" strokeWidth="2" />
                                                        <path d="M9 12L11 14L15 10" stroke="#fc9038" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                                    </svg>
                                                </div>
                                                <div>
                                                    <h3 style={{ fontSize: "1.1rem", color: "#fff", marginBottom: "8px", fontWeight: "600" }}>{item.title}</h3>
                                                    <p style={{ fontSize: "0.9rem", color: "rgba(255,255,255,0.6)", margin: 0, lineHeight: "1.6" }}>{item.desc}</p>
                                                </div>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </section>

                        {/* CTA Section */}
                        <section style={{ padding: "80px 0", background: "linear-gradient(135deg, rgba(252, 144, 56, 0.1) 0%, rgba(0, 2, 15, 0.5) 100%)" }}>
                            <div className="container text-center">
                                <h2 style={{ fontSize: "2.5rem", color: "#fff", marginBottom: "20px" }}>Let Us Manage Your Cloud</h2>
                                <p style={{ fontSize: "1.2rem", color: "rgba(255,255,255,0.7)", marginBottom: "30px" }}>
                                    Focus on your core business while our experts handle the rest.
                                </p>
                                <Link to="/contact-us" className="thm-btn agency-btn">
                                    <span className="text">Contact Us Today</span>
                                </Link>
                            </div>
                        </section>
                    </main>
                    <Footer />
                    <Scrollbar />
                </div>
            </div>
        </Fragment>
    );
};

export default ManagedCloudPage;
